import { useCallback, useEffect, useState } from "react";

export function useShowToolTip(itemRef) {
const [isOverflowing, setIsOverflowing] = useState(false);

  const checkOverflow = useCallback(() => {
    const el = itemRef.current;
    if (el) {
      setIsOverflowing(el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth);
    }
  }, []);

  useEffect(() => {
    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => window.removeEventListener('resize', checkOverflow);
  }, [checkOverflow, itemRef]);
  
  return isOverflowing;
}